(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     This directive allows Angular to listen for an Enter keypress event and trigger a function

     Reference:
     http://stackoverflow.com/questions/17470790/how-to-use-a-keypress-event-in-angularjs

     Usage example:
     <input ng-enter="funcToExecute()">

     */
    app.directive('ngEnter', [
        function () {
            return function (scope, element, attrs) {
                element.bind('keydown keypress', function (event) {
                    if (event.which === 13) {
                        scope.$applyAsync(function () {
                            scope.$eval(attrs.ngEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        }
    ]);
})(angular);